<div class="sf-container" *ngIf="sfDeviceAttribute" [@appear]="sfDeviceAttribute.factorySn">
  <mat-list class="sf-list">
    <mat-list-item *ngIf="sfDeviceAttribute.factorySn">
      <div matListItemTitle class="sf-item">
        <span class="bold-column">{{'devices.detail.sales-force.factory-sn' | translate}}</span>
        <span class="value-column">{{sfDeviceAttribute.factorySn}}</span>
      </div>
    </mat-list-item>
    <mat-list-item *ngIf="sfDeviceAttribute.businessLine">
      <div matListItemTitle class="sf-item">
        <span class="bold-column">{{'devices.detail.sales-force.business-line' | translate}}</span>
        <span class="value-column">{{sfDeviceAttribute.businessLine}}</span>
      </div>
    </mat-list-item>
    <mat-list-item *ngIf="sfDeviceAttribute.sfDeviceName">
      <div matListItemTitle class="sf-item">
        <span class="bold-column">{{'devices.detail.sales-force.device-name' | translate}}</span>
        <span class="value-column">{{sfDeviceAttribute.sfDeviceName}}</span>
      </div>
    </mat-list-item>
    <mat-list-item *ngIf="sfDeviceAttribute.sfProductName">
      <div matListItemTitle class="sf-item">
        <span class="bold-column">{{'devices.detail.sales-force.product-name' | translate}}</span>
        <span class="value-column">{{sfDeviceAttribute.sfProductName}}</span>
      </div>
    </mat-list-item>
    <mat-list-item *ngIf="sfDeviceAttribute.sfCustomerName">
      <div matListItemTitle class="sf-item">
        <span class="bold-column">{{'devices.detail.sales-force.customer-name' | translate}}</span>
        <span class="value-column">{{sfDeviceAttribute.sfCustomerName}}</span>
      </div>
    </mat-list-item>
  </mat-list>
  <mat-list class="sf-list" *ngIf="hasDeviceList">
    <mat-list-item *ngIf="sfDeviceAttribute.sfDeviceType">
      <div matListItemTitle class="sf-item">
        <span class="bold-column">{{'devices.detail.sales-force.device-type' | translate}}</span>
        <span class="value-column">{{sfDeviceAttribute.sfDeviceType}}</span>
      </div>
    </mat-list-item>
    <mat-list-item *ngIf="sfDeviceAttribute.deviceWidth">
      <div matListItemTitle class="sf-item">
        <span class="bold-column">{{'devices.detail.sales-force.device-width' | translate}}</span>
        <span class="value-column">{{sfDeviceAttribute.deviceWidth}}</span>
      </div>
    </mat-list-item>
    <mat-list-item *ngIf="sfDeviceAttribute.deviceLength">
      <div matListItemTitle class="sf-item">
        <span class="bold-column">{{'devices.detail.sales-force.device-length' | translate}}</span>
        <span class="value-column">{{sfDeviceAttribute.deviceLength}}</span>
      </div>
    </mat-list-item>
    <mat-list-item *ngIf="sfDeviceAttribute.deviceHeight">
      <div matListItemTitle class="sf-item">
        <span class="bold-column">{{'devices.detail.sales-force.device-height' | translate}}</span>
        <span class="value-column">{{sfDeviceAttribute.deviceHeight}}</span>
      </div>
    </mat-list-item>
  </mat-list>
  <mat-list class="sf-list" *ngIf="hasLocationList">
    <mat-list-item *ngIf="sfDeviceAttribute.sfHall">
      <div matListItemTitle class="sf-item">
        <span class="bold-column">{{'devices.detail.sales-force.hall' | translate}}</span>
        <span class="value-column">{{sfDeviceAttribute.sfHall}}</span>
      </div>
    </mat-list-item>
    <mat-list-item *ngIf="sfDeviceAttribute.sfLocation">
      <div matListItemTitle class="sf-item">
        <span class="bold-column">{{'devices.detail.sales-force.location' | translate}}</span>
        <span class="value-column">{{sfDeviceAttribute.sfLocation}}</span>
      </div>
    </mat-list-item>
    <mat-list-item *ngIf="sfDeviceAttribute.sfGateSignal">
      <div matListItemTitle class="sf-item">
        <span class="bold-column">{{'devices.detail.sales-force.gate-signal' | translate}}</span>
        <span class="value-column">{{sfDeviceAttribute.sfGateSignal}}</span>
      </div>
    </mat-list-item>
    <mat-list-item *ngIf="sfDeviceAttribute.sfGateControllerSide">
      <div matListItemTitle class="sf-item">
        <span class="bold-column">{{'devices.detail.sales-force.gate-controller-side' | translate}}</span>
        <span class="value-column">{{sfDeviceAttribute.sfGateControllerSide}}</span>
      </div>
    </mat-list-item>
  </mat-list>
  <mat-list class="sf-list">
    <mat-list-item *ngIf="sfDeviceAttribute.createdTimestamp">
      <div matListItemTitle class="sf-item">
        <span class="bold-column">{{'devices.detail.sales-force.created' | translate}}</span>
        <span class="value-column">{{sfDeviceAttribute.createdTimestamp | defaultDate }}</span>
      </div>
    </mat-list-item>
    <mat-list-item *ngIf="sfDeviceAttribute.lastUpdatedTimestamp">
      <div matListItemTitle class="sf-item">
        <span class="bold-column">{{'devices.detail.sales-force.last-updated' | translate}}</span>
        <span class="value-column">{{sfDeviceAttribute.lastUpdatedTimestamp | defaultDate }}</span>
      </div>
    </mat-list-item>
    <mat-list-item class="link-item" *ngIf="sfDeviceAttribute.bfId">
      <div matListItemTitle class="sf-item">
        <span class="bold-column">{{'devices.detail.sales-force.bf-id' | translate}}</span>
        <span class="value-column">{{sfDeviceAttribute.bfId}}<mat-icon color="primary" class="link-icon"
            *ngIf="bfAccessible && sfDeviceAttribute.bfId" (click)="selectId(deviceTypeKeys.SZT)">link</mat-icon></span>
      </div>
    </mat-list-item>
  </mat-list>
</div>